import styled from "styled-components/macro";
import { motion } from "framer-motion";

import {
  borderRadius,
  breakpoint,
  colors,
  fontSize,
  space,
  LEFT_CONTAINER_WIDTH,
  zIndex,
  FOOTER_HEIGHT,
  GRID_GAP_VERTICAL,
} from "shared/styles/constants";
import { HiddenDesktopContainer } from "shared/styles";
import { CloseButton } from "shared/components";
import { FancyButtonLink } from "../Link";

export const FilterContainer = styled(motion.div)`
  position: sticky;
  top: 0;

  height: 100vh;
  max-height: 100%;
  overflow-y: scroll;

  width: ${LEFT_CONTAINER_WIDTH}px;

  border-radius: 0 ${borderRadius.m} ${borderRadius.m} 0;

  margin-bottom: calc(${FOOTER_HEIGHT}px + ${GRID_GAP_VERTICAL});

  ${breakpoint("l", "down")} {
    overflow: hidden;

    display: flex;
    flex-direction: column;

    position: absolute;
    top: 0;

    width: 100vw;
    height: 100vh;

    z-index: ${zIndex.above};

    ${fontSize.base}
  }

  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;

    background-color: ${colors.black};
  }
`;

export const FilterContent = styled.div`
  position: relative;
  height: 100%;

  background-color: ${colors.blackLight};

  padding: ${space.l};
  flex-shrink: 1;
  flex-grow: 1;

  overflow-y: scroll;

  display: flex;
  flex-direction: column;

  > div + div {
    margin-top: ${space.l};
  }
`;

const FixedContainer = styled(HiddenDesktopContainer)`
  width: 100%;
  height: fit-content;

  z-index: ${zIndex.above};
`;

export const FilterFooter = styled(FixedContainer)`
  background-color: ${colors.white5};

  padding: ${space.xs} ${space.l};

  border-top: 1px solid ${colors.grey2};
`;

export const FilterHeader = styled(FixedContainer)`
  background-color: ${colors.white5};

  padding: ${space.m} ${space.l};

  border-bottom: 1px solid ${colors.grey2};

  align-items: center;
  justify-content: space-between;

  ${breakpoint("l", "down")} {
    display: flex;
  }
`;

export const StyledCloseButton = styled(CloseButton)`
  position: static;
`;

interface filterResetLinkProps {
  isVisible?: boolean;
}

export const FilterReset = styled(FancyButtonLink)<filterResetLinkProps>`
  visibility: ${({ isVisible }) => (isVisible ? "inherit" : "hidden")};

  align-self: flex-end;
  ${fontSize.xs};
`;
